import React, { useState, useEffect } from 'react';
import CardContainer from 'components/Tvendo/Common/CardContainer';
import CreateLayerDivitionModal from './CreateLayerDivitionModal';
import ReactTable from 'components/ReactTable/ReactTable';
import { Add, Delete, Edit } from '@material-ui/icons';
import Button from 'components/CustomButtons/Button';
import { Toasty, useToasty } from 'hooks/Toasty';
import { wsGetAll } from 'services/WService';
import { useModal } from 'hooks/useModal';
import { wsRemove } from 'services/WService';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 125 },
  { Header: 'Nombre', accessor: 'name' },
];

function LayerDivitionList() {
  const [layerDivitions, setLayerDivitions] = useState([]);
  const [createModal, setCreateModal] = useModal();
  const [notify, showNotify] = useToasty();
  const [dataLoading, setDataLoading] = useState(false);

  async function listLayerDivitions() {
    setDataLoading(true);
    let res = await wsGetAll('base/layer-divition');
    setDataLoading(false);
    setLayerDivitions(res.data);
  }

  async function deleteLayerDivition(layer) {
    setDataLoading(true);
    let res = await wsRemove('base/layer-divition', layer.id);
    setDataLoading(false);
    if (res.success) {
      showNotify(res.message);
      listLayerDivitions();
    } else {
      showNotify(res.message, 'error');
    }
  }

  useEffect(() => {
    listLayerDivitions();
  }, []);

  return (
    <CardContainer
      // title="Listado de agrupamiento capas"
      title={(<>Listado de agrupamiento capas {dataLoading && <LoadingSpinner />}</>)}
      icon={<Add />}
      onClick={() => {
        setCreateModal({ open: true });
      }}
    >
      <Toasty action={notify} />
      <CreateLayerDivitionModal
        model={createModal}
        setOpen={setCreateModal}
        showNotify={showNotify}
        reload={listLayerDivitions}
      />
      <ReactTable
        columns={columns}
        data={layerDivitions.map((layer, index) => {
          return {
            ...layer,
            num: (
              <div className="actions-right">
                {index + 1}
                <Button
                  justIcon
                  round
                  simple
                  color="warning"
                  onClick={() => {
                    setCreateModal({ ...layer, open: true });
                  }}
                >
                  <Edit />
                </Button>
                <Button
                  justIcon
                  round
                  simple
                  color="danger"
                  onClick={() => deleteLayerDivition(layer)}
                >
                  <Delete />
                </Button>
              </div>
            ),
          };
        })}
        exportExcel={false}
      />
    </CardContainer>
  );
}

export default LayerDivitionList;
